/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

import type { Root } from 'react-dom/client';
import type { RefObject } from 'react';

import { NotificationDialogsWrapper } from './components';
import { getPortalContainer } from '../../helpers/react-helpers';

import type { NotificationDialogsWrapperProps } from './components';

export class NotificationDialogsAdapter {

    protected notificationContainer: HTMLElement | null = null;
    protected currentNotification: React.RefObject<NotificationDialogsWrapper> = React.createRef<NotificationDialogsWrapper>();
    protected notificationRoot: Root;
    protected containerId: string;

    constructor(containerId = 'notification-dialogs-adapter') {
        this.containerId = containerId;
    }

    showDialog(props: NotificationDialogsWrapperProps, containerRef?: RefObject<HTMLElement>): Promise<void> {
        return new Promise<void>((resolve) => {
            const wrapperProps: NotificationDialogsWrapperProps & React.ClassAttributes<NotificationDialogsWrapper> = {
                ...props,
                containerRef,
                ref: this.currentNotification,
            };
            const container = getPortalContainer(this.containerId);
            const NotificationDialogsAdapterWithAfterRender = () => {
                useEffect(() => {
                    resolve();
                }, []);

                return React.createElement(NotificationDialogsWrapper, wrapperProps);
            };

            this.notificationRoot = createRoot(container);
            this.notificationRoot.render(<NotificationDialogsAdapterWithAfterRender />);
        })
            .then(() => this.currentNotification.current?.showDialog());
    }

    hideDialog(): void {
        this.currentNotification.current?.hideDialog();
        this.notificationRoot.unmount();
    }

    destroy(): void {
        this.hideDialog();
        this.removeNotificationContainer();
        this.currentNotification = null;
    }

    protected removeNotificationContainer(): void {
        this.notificationContainer?.remove();
        this.notificationContainer = null;
    }

}
